import { useState } from 'react';
import { Col, Container, Row, Modal, Button, Ratio } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';
import { createUseThemedStyles, useNavigationConfig } from '@/hooks';
import { ReactComponent as DwcMatrixIcon } from '@/assets/icons/hackett-dwc-matrix-icon.svg';
import { ReactComponent as ResearchReportsIcon } from '@/assets/icons/hackett-research-reports-icon.svg';
import { ReactComponent as CustomContentIcon } from '@/assets/icons/hackett-custom-content-icon.svg';
import { ReactComponent as HackettLogo } from '@/assets/logos/logo-hackett.svg';

const useStyles = createUseThemedStyles({
	iconOuter: {
		width: 160,
		height: 'auto',
		display: 'block',
		margin: '0 auto 8px',
	},
});

export const SolutionIntelligence = () => {
	const classes = useStyles();
	const { navigationConfig } = useNavigationConfig();
	const [showLearnMoreModal, setShowLearnMoreModal] = useState(false);

	return (
		<>
			<Helmet>
				<title>Hackett Connect - Solution Intelligence</title>
			</Helmet>

			<Container className="bg-white" fluid>
				<Container className="py-11">
					<Row>
						<Col>
							<h1 className="mb-4 text-primary">Solution Intelligence for Buyers</h1>
							<p>
								The Hackett Group's Solution Intelligence program combines independent, data-backed
								vendor assessments with expert guidance to structure evaluations, clarify trade-offs and
								build a defensible shortlist aligned with your operating context and objectives. Experts
								also support readiness before implementation and post-deployment optimization to help
								ensure expected outcomes are realized.
							</p>
						</Col>
					</Row>
				</Container>
			</Container>

			<Container className="bg-gray-100" fluid>
				<Container className="py-11">
					<Row className="mb-4">
						<Col>
							<h2 className="mb-4 text-primary">Resources Available in Hackett Connect&reg;</h2>
							<p className="mb-0">
								Featured Solution Intelligence for Buyers' insights are available to you in your member
								programs, including:
							</p>
						</Col>
					</Row>
					<Row className="mb-4">
						<Col lg={4} className="mb-4">
							<DwcMatrixIcon className={classNames(classes.iconOuter, 'text-danger')} />
							<h4 className="mb-2 text-uppercase text-danger text-center">
								Software and Service Vendor Assessments
							</h4>
							<p className="mb-0 text-center">
								Grounded in deep process expertise and Digital World Class&reg; performance standards,
								these reports measure how effectively solutions enable measurable ROI
							</p>
						</Col>
						<Col lg={4} className="mb-4">
							<ResearchReportsIcon className={classNames(classes.iconOuter, 'text-secondary')} />
							<h4 className="mb-2 text-uppercase text-secondary text-center">Vendor Profiles</h4>
							<p className="mb-0 text-center">
								Comprehensive profiles of software and service vendors, including company overview,
								strategic vision, product portfolio, core capabilities, representative clients and key
								partnerships
							</p>
						</Col>
						<Col lg={4} className="mb-4">
							<CustomContentIcon className={classNames(classes.iconOuter, 'text-warning')} />
							<h4 className="mb-2 text-uppercase text-warning text-center">
								Solution Intelligence Research
							</h4>
							<p className="mb-0 text-center">
								Vendor spotlight reports, market perspectives on evolving technology trends, and curated
								insights from podcasts, webcasts, and major vendor conferences and events provide
								context to stay current, identify emerging capabilities, and make more informed
								decisions
							</p>
						</Col>
					</Row>
					<Row>
						<Col>
							<div className="text-center">
								<button
									className="hackett-button hackett-button-secondary"
									type="button"
									onClick={() => {
										setShowLearnMoreModal(true);
									}}
								>
									Learn More
								</button>
							</div>
						</Col>
					</Row>
				</Container>
			</Container>

			<Modal size="lg" centered show={showLearnMoreModal}>
				<Modal.Header>
					<HackettLogo width={190} height={24} />
				</Modal.Header>
				<Modal.Body>
					<Ratio aspectRatio="16x9">
						<video autoPlay width="350" height="auto" controls>
							<source
								src={navigationConfig && navigationConfig.marketIntelligenceLearnMoreVideoUrl}
								type="video/mp4"
							/>
							Your browser does not support the video tag.
						</video>
					</Ratio>
				</Modal.Body>
				<Modal.Footer>
					<Button
						onClick={() => {
							setShowLearnMoreModal(false);
						}}
					>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};
